import React, {Component} from 'react';
import { connect } from "react-redux";
import Layout from '../../components/layout/layout';
import BannerLogo from '../../components/logo/logo';
import Util from '../../utils/util';
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import './home.scss';
import MainLink from '../../components/main-link/main-link';
import MainButton from '../../components/main-button/main-button';
import cameraBlackIcon from "../../static/camera-black.svg";
import birthdaySurprizeIcon from "../../static/BIRTHDAY_SURPRISE_60X50.svg";
import freeShippingIcon from "../../static/FREE_DELIVERY_60X50.svg";
import invitationIcon from "../../static/MEMBERS_ONLY_EVENTS_60X50.svg";
import giftIcon from "../../static/GIFT_WITH_PURCHASE_60X50.svg";
import insiderExclusiveIcon from "../../static/MEMBERS_ONLY_60X50.svg";
import earlyAccessIcon from "../../static/EARLY_ACCESS_60X50.svg";
import returnsIcon from "../../static/FREE_RETURNS_60X50.svg";
import personalizationIcon from "../../static/PERSONALIZED_OFFERS_60X50.svg";
import insiderImage from "../../static/home-insider-img.jpg";
import lockIcon from "../../static/lock.svg";
import arBanner from "../../static/peanuts-banner.jpg";
import successCheck from "../../static/check_circle_icon.png";
import FullScreenModal from '../../components/full-screen-modal/full-screen-modal';
import ProductDropCard from '../../components/product-drop-card/product-drop-card';
import insiderImageLoggedIn from '../../static/new-arrivals-logged-in.jpg';
import closeIcon from '../../static/close.svg';
import {inLineSettings, signupForAlerts} from "../../actions/product";
import MiniNavbar from '../../components/mini-navbar/mini-navbar';
import ARUtil from '../../utils/AR.util';
import FloatingWidget from '../../components/floating-widget/floating-widget';
import CommonModal from "../../components/common-modal/common-modal";
import MainInput from "../../components/main-input/main-input";
import NumberFormat from 'react-number-format';
import { floatingWidgetVariant } from '../../animations/home.variants';
import SignInOverlay from '../../components/signin-overlay/signin-overlay';
import closeImage from '../../static/close.svg';
import showPasswordEye from "../../static/show-password-eye.svg";
import passwordDontShowEye from "../../static/dont-show-password-eye.svg";
import SquareCheckbox from "../../components/checkbox-square/checkbox-square";
import ErrorMessage from "../../components/error-message-label/error-message-label";
import { setEmailOptIn } from "../../actions/store";
import {
    setGuestToken,
    createAccount,
    updateAccount,
    triggerWelcomeEmail,
    getPersonalizedPromos
  } from "../../actions/account";
import infinite from "../../static/Infinte.png";
import birthdayIcon from "../../static/Birthday.png";
import offersIcon from "../../static/offers.png";
import watch from "../../static/Watch.png";
import { sha256 } from 'js-sha256';
import ARSlot from '../../components/AR-slot/AR-slot';
import dsaInsider from "../../static/DSA-mobile__01.jpg";
import dsaLoggedInInsider from "../../static/DSA-logged-in-mobile__01.jpg";
import homePageSlotBanner from '../../static/teri-altered.png';


const ERROR_LABELS = {
    EMAIL: {
      EMPTY: "EEMPTY",
      INVALID: "EINVALID",
      INUSE: "INUSE"
    },
    PASSWORD: {
      EMPTY: "PEMPTY",
      CEMPTY: "CPEMPTY",
      INVALID: "PINVALID",
      MISMATCH: "PMISMATCH"
    }
  };

class Home extends Component {
    state = {
        isIntroVisible: false,
        lastSlide: false,
        isRewardExpanded: false,
        isTermsVisible: false,
        showFloatingLabel: false,
        isHomePage:true,
        isPromotionImpression:false,
        is25percPassed: false,
        is50percPassed: false,
        is75percPassed: false,
        is100percPassed: false,
        floatingLabelVisibilityTimedOut: false,
        floatingLabelAnimation: 'floatingLabelHide',
        carouselTotalItemsCount: 2,  //starting from 0
        productDropCarouselSelectedItemIndex: 0,
        showTermsContainer: true,
        isShopInlineAllowedTime: false,
        shopInLineEnabled: false,
        shopInLineRequestLimit: 0,
        productDropSelectedCategory: '',
        showARLENEXRElement: false,
        showFloatingWidget: true,
        isAttentivePopUpVisible:false,
        optInSuccessful:false,
        atttentiveEmail:'',
        attentivePhone:'',
        validationMessageEmail:'',
        validationMessagePhone:'',
        optInValidation:'',
        user: {
            first_name: "",
            last_name: "",
            email: "",
            password: "",
            cpassword: ""
          },
          firstNameError: false,
          lastNameError: false,
          emailError: "",
          emailInUseError: "",
          passwordError: "",
          cPasswordError: "",
          showPassword: false,
          showCPassword: false,
          isBirthdayVisible: false,
          birthMonth: "",
          birthDay: "",
          isBirthdayError: false,
          showPasswodHint: false,
          invalidFirstName: false,
          invalidLastName: false,
          showSignUpOverlay: true,
          showSignInOverlay: false,
    };

    /* stores previous intro sliding position.
        cannot be added into state object as updating this variable triggers the carousel to go back to first item. */
    carouselPrevItemPosition = 0; 

    productDropCarouselDragStartX = 0;
    productDropCarouselDragStartY = 0;

    productDropData = {};
    productDropCategoriesSizeMapSorted = {};

    isARScriptLoaded = false;
    ARExperienceEnabled = false;

    constructor(props) {
        
        super(props);
        this.ARSlotRef = React.createRef();
        this.ARSlotImpressionEventFired = false;
        this.insiderGateGroup = Util.getInsiderGateGroup();
        this.isLoggedIn = Util.isUserLoggedIn();

        let storeDetails = Util.getObjectFromStorage(Util.STORE_DETAILS);
        if (storeDetails && storeDetails.config && storeDetails.config.ARSettings) {
            const parsedARConfig = JSON.parse(storeDetails.config.ARSettings);
            this.ARSettings = parsedARConfig;
        }
    }   

    componentDidMount() {

        this.initializeHomePageInternals();
        const shouldShowIntroCarousel = this.shouldShowIntroCarousel();

        document.title = 'Coach Home Page';
        Util.clearCookie(Util.COOKIE_NAMES.PREVIOUS_PAGE);
        Util.removeFromSessionStorage(Util.PRODUCT_LIST_SCROLL_ID);
        Util.removeFromSessionStorage(Util.PRODUCT_LIST_LOADED_COUNT);
        Util.removeFromSessionStorage(Util.PRODUCT_LIST_SCROLL_POSITION_FOR_PDP);
        Util.scrollTop();
        this.setState({isPromotionImpression:false})
        dataLayer.push({
            'event': 'dataLayer-initialized',
            'customAttributes':Util.getCustomAttributes(),
            'userID': Util.getEmailId(),
            'language': Util.getSelectedLanguage(),
            'pageName': 'Home',
            'pageType': 'Home',
            'storeID': Util.getStoreDetails().storeId,
            'storeDesc': Util.getStoreDetails().name,
            'flowConfig': Util.getGAFlowConfig(),
            signedIn: (Util.isUserLoggedIn() == Util.LOGGEDIN_STATUS.LOGGED_IN) ? 'signed-in user' : 'guest'
        });
        if(Util.isSignupSessionLoggedOut())
        {
            // this.onSignUpOverlaySignInClick()
            Util.removeStringFromStorage(Util.IS_SIGNUP_SESSION_LOGGED_OUT);
        }
        // window.addEventListener('scroll', this.showFloatingLabel);
        window.addEventListener('scroll', this.percentage);
        if (shouldShowIntroCarousel) {
            this.toggleIntroModalVisibility(true, () => {
                dataLayer.push({
                    'event': 'appPageView',
                    'appPageName': this.insiderGateGroup === Util.INSIDER_GATE_GROUPS.WITHOUT_INSIDER_GATE ? 'intro: check price and savings:' : 'intro: onboarding introduction carousel',
                    'flowConfig': Util.getGAFlowConfig()
                })
                const finalNextButton = document.querySelector('.control-arrow.control-next');
                if (finalNextButton) {
                    finalNextButton.addEventListener('click', (event) => {
                        if (event.target.className.indexOf('control-disabled') >= 0) {
                            this.toggleIntroModalVisibility(false);
                        }
                    });
                }
            });
        }
    
        if (this.insiderGateGroup === Util.INSIDER_GATE_GROUPS.WITHOUT_INSIDER_GATE) {
            this.state.isHomePage? (
                dataLayer.push({
                'event': 'appPageView',
                'appPageName': 'home',
                'flowConfig': Util.getGAFlowConfig()
            })
            ):''; 
        }
        const storeDetails = Util.getStoreDetails();
        window.addEventListener('scroll', this.onWindowScroll);
        let storeInfo = Util.getObjectFromStorage(Util.STORE_DETAILS);
        const shopInLineTimeObj = storeInfo.shopInLineTime ? JSON.parse(storeInfo.shopInLineTime) : {};
        const shopInLineDefaultTimeObj = storeInfo.config.defaultShopInLineTime ? JSON.parse(storeInfo.config.defaultShopInLineTime) : {};
        const requestForLineSettings = {
            timeZone: storeInfo.timeZone,
            timeDifferenceEST: storeInfo.timeDifferenceEST,
            shopInLineStartTime: shopInLineTimeObj.startTime || shopInLineDefaultTimeObj.startTime,
            shopInLineEndTime: shopInLineTimeObj.endTime || shopInLineDefaultTimeObj.endTime
        };
        this.props.inLineSettings(requestForLineSettings, storeDetails.storeId)
        .then(response => {
            if (response && response.status == "SUCCESS") {
                this.setState({isShopInlineAllowedTime: response.isShopInLineAllowedTime || false});
                this.setState({shopInLineEnabled: response.shopInLineEnabled || false});
                this.setState({shopInLineRequestLimit: response.shopInLineRequestLimit || 0});
            }
        });

        if (this.productDropData && this.productDropData.categories && this.productDropData.categories.length) {
            this.setState({productDropSelectedCategory: this.productDropData.categories[0].id});
        }


        // filling productDropCategoriesSizeMap which is used for categorized infinite scrolling.
        let productDropCategoriesSizeMap = {};
        if (this.productDropData && this.productDropData.slides) {
            this.productDropData.slides.forEach(item => {    
                if (item.category) {
                    productDropCategoriesSizeMap[item.category] = (productDropCategoriesSizeMap[item.category] + 1) || 1;
                }
           });
        }

        // sorting out productDropCategoriesSizeMap based on initial map to ensure category switching will be proper.
        if (this.productDropData.categories) {
            this.productDropData.categories.forEach(category => {
                if (category.id) {
                    this.productDropCategoriesSizeMapSorted[category.id] = productDropCategoriesSizeMap[category.id];
                }
            });
        }

        /* calculating the no of slides required to pass for reaching next category 
        which will be used in productdropItemChangeHnadler to automatically switching category for infinite swiping */
        Object.keys(this.productDropCategoriesSizeMapSorted).reduce((acc, curr) => {
            acc += this.productDropCategoriesSizeMapSorted[curr];
            this.productDropCategoriesSizeMapSorted[curr] = acc;
            return acc;
        }, 0);

        this.checkAndFireARSlotImpressionEvent();
        if(this.shouldShowAttentiveFloatingWIdget()){
            dataLayer.push({
                'event': 'attentiveInteraction',
                'eventAction': 'attentive banner impression',  
                'eventLabel': 'sign up for texts and get $10 off'
            });
        }
        if (this.isLoggedIn != Util.LOGGEDIN_STATUS.LOGGED_IN) {
            Util.setCurrentHistoryObj(this.props.history);
            const storeDetail = Util.getStoreDetails();
            this.props.setGuestToken(storeDetail.countryCode);
            if (storeDetail && storeDetail.countryCode == 'CAN') {
              storeDetail.isEmailOptIn = false;
              this.props.setEmailOptIn(false);
            } else {
              storeDetail.isEmailOptIn = true;
              this.props.setEmailOptIn(true);
            }
                Util.addObjectToStorage(Util.STORE_DETAILS, storeDetail);
          }
    }

    initializeHomePageInternals = () => {

        // use to set internal variables which is used throughout this component
        if (this.ARSettings && this.ARSettings.enabled) {
            this.ARExperienceEnabled = true;
        }
    }

    shouldShowIntroCarousel = () => {

        const isLoggedIn = Util.isUserLoggedIn();

        let showIntroCarousel = true;
        if (this.ARExperienceEnabled && this.insiderGateGroup === Util.INSIDER_GATE_GROUPS.WITHOUT_INSIDER_GATE) {
            showIntroCarousel = false;
        }

        if (this.insiderGateGroup !== Util.INSIDER_GATE_GROUPS.WITHOUT_INSIDER_GATE && Util.isECatalogueFlow()) {
            showIntroCarousel = false;
        }

        if (this.insiderGateGroup !== Util.INSIDER_GATE_GROUPS.WITHOUT_INSIDER_GATE && isLoggedIn === Util.LOGGEDIN_STATUS.LOGGED_IN) {
            showIntroCarousel = false;
        }

        // disabling intro carousel for all stores.
        if (this.insiderGateGroup === Util.INSIDER_GATE_GROUPS.WITHOUT_INSIDER_GATE) {
            showIntroCarousel = false;
        }

        return showIntroCarousel;
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onWindowScroll);
        window.removeEventListener('scroll', this.showFloatingLabel);
        window.removeEventListener('scroll', this.percentage);
    }
    personalizedPromos=()=>{
        Util.removeFromSessionStorage(Util.PERSONALIZED_PROMO_LIST);
        Util.clearCookie(Util.COOKIE_NAMES.PREVIOUS_PAGE);
        Util.removeFromSessionStorage(Util.PRODUCT_LIST_SCROLL_ID);
        Util.removeFromSessionStorage(Util.PRODUCT_LIST_LOADED_COUNT);
        Util.removeFromSessionStorage(Util.PRODUCT_LIST_SCROLL_POSITION_FOR_PDP);

        this.props.getPersonalizedPromos().then(data => {
            let personalizedPromosList = [];
            if (data && data.personalizedPromosList) {
            personalizedPromosList = data.personalizedPromosList;
            }
            Util.addObjectToSessionStorage(Util.PERSONALIZED_PROMO_LIST, personalizedPromosList);
        })
    }

    percentage = () => {
        let scrollTop = window.scrollY;
        let docHeight = document.body.offsetHeight;
        let winHeight = window.innerHeight;
        let scrollPercent = scrollTop / (docHeight - winHeight);
        let perc = Math.round(scrollPercent * 100);
        if (perc <= 25 && !this.state.is25percPassed) {
            Util.dataLayerScroll(window.location.pathname,25)
            this.setState({is25percPassed:true})
        }
        else if(perc > 25 && perc <=50 && !this.state.is50percPassed){
            Util.dataLayerScroll(window.location.pathname,50)
            this.setState({is50percPassed:true})

        }
        else if(perc > 50 && perc <= 75 && !this.state.is75percPassed){
            Util.dataLayerScroll(window.location.pathname,75)
            this.setState({is75percPassed:true})
            
        }
        else if(perc > 75 && perc <= 100 && !this.state.is100percPassed){
            Util.dataLayerScroll(window.location.pathname,100)
            this.setState({is100percPassed:true})

        }
    
    }
    showFloatingLabel = () => {
        
        const BOTTOM_VISIBILITY_THRESHOLD = 80;
        const VISIBILITY_TIMEOUT = 2500;
        const topThresholdElementClass = '.image-container';
        const top = document.querySelector(topThresholdElementClass).offsetTop;
        const isReachedVisibilityHeight = (top <= (window.innerHeight + window.scrollY - BOTTOM_VISIBILITY_THRESHOLD));
       
        if (isReachedVisibilityHeight) {

            // setTimeout(() => {
            //     this.setState({floatingLabelVisibilityTimedOut: true});
            // }, VISIBILITY_TIMEOUT);

            if (!this.state.showFloatingLabel) {
                this.setState({showFloatingLabel: true});
                this.setState({floatingLabelAnimation: "floatingLabelFadeIn"});
                setTimeout(() => {
                    this.setState({floatingLabelAnimation: "floatingLabelFadeOut"});
                }, VISIBILITY_TIMEOUT);
            }
        }

        // if (isReachedVisibilityHeight && !this.state.floatingLabelVisibilityTimedOut) {
            // this.setState({floatingLabelAnimation: "floatingLabelFadeIn"});
        //     return;
        // }

        // if (this.state.floatingLabelVisibilityTimedOut && this.state.floatingLabelAnimation == "floatingLabelFadeIn") {
        //     this.setState({floatingLabelAnimation: "floatingLabelFadeOut"}); 
        // }
        
    }

    onTermsOfUseClick = () => {
        dataLayer.push({
            'event': 'outboundLink',
            'linkAction': 'Terms and conditions'
           });
    }
    onPrivacyPolicyClick = () => {
        dataLayer.push({
            'event': 'outboundLink',
            'linkAction': 'Privacy Policy'
           });
    }

    onFloatingLabelClick = () => {
        window.toggleBarcodeScanner(true);
    }
    onClickAttentive = () => {
        dataLayer.push({
            'event': 'attentiveInteraction',
            'eventAction': 'attentive modal impression',
            'eventLabel': 'sign up for texts and get $10 off'
        });
        this.setState({isAttentivePopUpVisible:true})
    }
    onAttentivePopupCloseClick = () => {
        this.setState({ isAttentivePopUpVisible: false })
        if (!this.state.optInSuccessful) {
            dataLayer.push({
                'event': 'attentiveInteraction',
                'eventAction': 'attentive modal close',
                'eventLabel': 'sign up for texts and get $10 off'
            });
            this.setState({validationMessageEmail:'', validationMessagePhone:'', optInValidation:''});
        }
        else {
            // this.setState({ isAttentivePopUpVisible: false })
            Util.addStringToStorage(Util.SHOW_ATTENTIVE_FLOATING_POPUP, 'false');
            this.setState({ showFloatingWidget: false })
            this.setState({ optInSuccessful: false })
        }
    }
    attentiveWidgetAvailability=()=>{
        let storeInfo = Util.getObjectFromStorage(Util.STORE_DETAILS);
        let country = storeInfo.config.attentiveWidgetAvailability
        country = country.split(",")
        if(country.includes(storeInfo.countryCode))
        return true
        else return false

    }

    onChangeInput = (field, value) => {
        let updateObj = {};
        updateObj[field] = value;
        this.setState(updateObj);
      }
      signUpAlerts() {
        const { atttentiveEmail, attentivePhone } = this.state;
        let validationMessageEmail = '';
        let validationMessagePhone = '';
        let common = {};
        let pdp = {};
        if (this.props.locale && this.props.locale.screens) {
        common = this.props.locale.screens.common;
        pdp = this.props.locale.screens.productDetail;
        }
        if (!atttentiveEmail) {
            validationMessageEmail = common.enterEmail;
            this.setState({validationMessageEmail});
        } else if (!Util.isValidEmail(atttentiveEmail)) {
            validationMessageEmail = common.enterValidEmail;
            dataLayer.push({
                'event': 'attentiveInteraction',
                'eventAction': 'attentive sign up form error',
                'eventLabel': 'Please enter a valid email address'
            });
            this.setState({validationMessageEmail});
        } else if (!attentivePhone) {

            validationMessageEmail = '';
            validationMessagePhone = common.enterPhone;
            this.setState({
            ...this.state,
            validationMessageEmail,
            validationMessagePhone
            });
        } else if (!Util.isValidPhone(Util.getRawPhoneNumber(attentivePhone).trim())) {

            validationMessageEmail = '';
            validationMessagePhone = common.validMobileNumber;
            dataLayer.push({
                'event': 'attentiveInteraction',
                'eventAction': 'attentive sign up form error',
                'eventLabel': 'Please enter a valid Mobile number'
            });
            this.setState({
            ...this.state,
            validationMessageEmail,
            validationMessagePhone
            });
        } else {
            this.setState({validationMessageEmail:'', validationMessagePhone:''});
            const requestObj = {
                user: {
                    phone: "+1" + Util.getRawPhoneNumber(attentivePhone),
                    email: atttentiveEmail
                },
                signUpSourceId: "108134"
            };
            this.props.signupForAlerts(requestObj)
                .then(response => {
                    if (response.status == "Success") {
                        dataLayer.push({
                            'event': 'attentiveInteraction',
                            'eventAction': 'attentive sign up successful',
                            'eventLabel': 'sign up for texts and get $10 off'
                        });
                        this.setState({ optInSuccessful: true })
                        setTimeout(() => {
                            this.setState({isAttentivePopUpVisible:false})
                            Util.addStringToStorage(Util.SHOW_ATTENTIVE_FLOATING_POPUP, 'false');
                            this.setState({ showFloatingWidget: false })
                            this.setState({ optInSuccessful: false })
                            
                        }, 10000);
                    }
                    else if(response.status == "AlreadySubscribed")
                    {
                        dataLayer.push({
                            'event': 'attentiveInteraction',
                            'eventAction': 'attentive sign up form error',
                            'eventLabel': 'looks like you\'re already subscribed'
                        });
                        this.setState({ optInValidation: common.alreadySubscribed })
                    }
                    else
                    {
                        this.setState({ optInValidation: "Something went wrong" })

                    }
                })
            .catch(error => {
                console.log(error)
                this.setState({ optInValidation: "Something went wrong" })
             });
        }
  }

    onProductDropCarouselSwipeStart = (touchMoveEvent) => {

        this.productDropCarouselDragStartX = touchMoveEvent.changedTouches[0].screenX; 
        this.productDropCarouselDragStartY = touchMoveEvent.changedTouches[0].screenY; 
    }

    onProductDropCarouselSwipeMove = (changedTouches) => {

        const X_THRESHOLD = 5;
        const Y_THRESHOLD = 2;
        
        if (Math.abs(this.productDropCarouselDragStartX - changedTouches.screenX) >= X_THRESHOLD &&
            Math.abs(this.productDropCarouselDragStartY - changedTouches.screenY) <= Y_THRESHOLD) {
 
                 document.body.style.overflow = 'hidden';
             }
     }

    onProductDropCarouselSwipeEnd = (productDropCarouselDragEndX) => {
        const MIN_THRESHOLD_PX = 50;
        const swipeLength = Math.abs(this.productDropCarouselDragStartX - productDropCarouselDragEndX);
        const isQualifiedSwipe = swipeLength.toFixed() != 0 && swipeLength >= MIN_THRESHOLD_PX;
        if (isQualifiedSwipe) {
            const isRightSwipe = this.productDropCarouselDragStartX > productDropCarouselDragEndX;
            if (isRightSwipe) {
                document.querySelector('.control-arrow.control-next').click();
            } else {
                document.querySelector('.control-arrow.control-prev').click();
            }
        }
        document.body.style.overflow = 'unset';
    }

    hideTermsContainer = () => {
        this.setState({showTermsContainer: false});
        Util.addStringToStorage(Util.IS_HOME_TERMS_CLOSED, true);
    }

    onNavbarItemClick = (categoryIndex) => {
        this.setState({productDropSelectedCategory: categoryIndex});
        const elapsedSlidesCount = this.productDropCategoriesSizeMapSorted[categoryIndex];
        if (elapsedSlidesCount) {
            if ( this.productDropData && this.productDropData.slides && this.productDropData.slides.length) {
                    const categoryItemsCount = this.productDropData.slides.reduce((acc, curr) => {
                        if (curr && curr.category && curr.category === categoryIndex) {
                            acc++;
                        }
                        return acc;
                    }, 0);
                    this.setState({productDropCarouselSelectedItemIndex: (elapsedSlidesCount - categoryItemsCount)});
                }
        }
    }

    onProductDropCarouselItemChange = (itemIndex) => {

        this.setState({productDropCarouselSelectedItemIndex: itemIndex});
        for (let [categoryId, elapsedSlidesCount] of Object.entries(this.productDropCategoriesSizeMapSorted)) {
            if (itemIndex < elapsedSlidesCount) {
                this.setState({productDropSelectedCategory: categoryId});
                break;
            }
        }
    }

    onARExperinceClose = () => {

        console.log('inside ar experince close callback');
        this.setState({showARLENEXRElement: false});
        Util.removeScript(Util.HOME_AR_EXPERINCE_ENTRYPOINT_SCRIPT_LOCATION);
        window.removeEventListener('xr-session-closed', this.onARExperinceClose);
    }

    onARBannerClick = () => {

        dataLayer.push({
            'event': 'promotionClick',
            'location':'home',
            'ecommerce': {
                'promoClick': {
                'promotions': [
                        {
                        'id': 'TAKE A SELFIE WITH SNOOPY',
                        'name': 'TAKE A SELFIE WITH SNOOPY',
                        'creative': 'peanuts-banner.jpg',
                        'position': 'banner_slot_1'
                        },
                    ]
                }
            }
        });
        window.open(ARUtil.getHomeScreenARExperienceRedirectionLink());
    }

    shouldShowAttentiveFloatingWIdget = () => {
        let showFloatingWidget = true;
        const showPopup = Util.getStringFromStorage(Util.SHOW_ATTENTIVE_FLOATING_POPUP) || 'true';
        if (showPopup === 'false' || !this.attentiveWidgetAvailability() || Util.isUserLoggedIn() === Util.LOGGEDIN_STATUS.LOGGED_IN) {
            showFloatingWidget = false;
        }
        return showFloatingWidget;
    }

    onARBannerDisclaimerLinkClick = (event) => {
        event.stopPropagation();
    }

    onIntroCarouselSignUpClick = () => {
        this.toggleIntroModalVisibility(false, () => this.setState({ showSignUpOverlay: true}));
        this.handleSignUpOverlayGAEvents();
        this.toggleIntroModalVisibility(false, () => this.setState({ showSignUpOverlay: true }, () => {
            dataLayer.push({
                'event': 'membershipInteraction',
                'membershipEventType': 'sign up',
                'membershipEventTitle': 'Become an Insider',
                'membershipEventCTA': 'create account',
                'membershipEventAction': 'impression',
                'membershipEventLocation':this.insiderGateGroup === Util.INSIDER_GATE_GROUPS.WITH_INSIDER_GATE_AND_INCENTIVE ? 'gwp sign-up':'non gwp sign-up'
            });
        }));
        dataLayer.push({
            'event': 'membershipInteraction',
            'membershipEventType': 'sign up',
            'membershipEventTitle': 'create account',
            'membershipEventCTA': 'create account',
            'membershipEventAction': 'click',
            'membershipEventLocation': this.insiderGateGroup === Util.INSIDER_GATE_GROUPS.WITH_INSIDER_GATE_AND_INCENTIVE ? 'gwp sign-up':'non gwp sign-up'
        });
    }

    onIntroCarouselSignInClick = () => {
        this.toggleIntroModalVisibility(false, () => this.setState({ showSignInOverlay: true, showSignUpOverlay: false }, () => {
            dataLayer.push({
                'event': 'membershipInteraction',
                'membershipEventType': 'login',
                'membershipEventTitle': 'Welcome Back to Coach Outlet',
                'membershipEventCTA': 'sign in',
                'membershipEventAction': 'impression',
                'membershipEventLocation': this.insiderGateGroup === Util.INSIDER_GATE_GROUPS.WITH_INSIDER_GATE_AND_INCENTIVE ? 'gwp sign-in' : 'non gwp sign-in'
            });
        }));
        dataLayer.push({
            'event': 'membershipInteraction',
            'membershipEventType': 'login',
            'membershipEventTitle': 'sign in',
            'membershipEventCTA': 'sign in',
            'membershipEventAction': 'click',
            'membershipEventLocation': this.insiderGateGroup === Util.INSIDER_GATE_GROUPS.WITH_INSIDER_GATE_AND_INCENTIVE ? 'gwp sign-in':'non gwp sign-in'
        });
    }

    onSignUpOverlaySignInClick = () => {
        this.setState({showSignInOverlay: true, showSignUpOverlay: false});
    }

    onSignInOverlaySignUpClick = () => {
        const storeDetail = Util.getStoreDetails();
        this.props.setGuestToken(storeDetail.countryCode);
        this.setState({showSignUpOverlay: true, showSignInOverlay: false});
        this.handleSignUpOverlayGAEvents();
    }

    onSignInOverlaySignInSuccess = () => {
        this.setState({showSignInOverlay: false});
        Util.scrollTop();
    }

    onIntroModalClose = () => {
        this.toggleIntroModalVisibility(false);
        this.handleSignUpOverlayGAEvents();
    }

    handleSignUpOverlayGAEvents = () => {
        if (this.insiderGateGroup === Util.INSIDER_GATE_GROUPS.WITH_INSIDER_GATE_AND_INCENTIVE) {
            dataLayer.push({
                'event': 'appPageView',
                'appPageName': 'home: gwp become a coach insider',
                'flowConfig': Util.getGAFlowConfig()
            });
        } else if (this.insiderGateGroup === Util.INSIDER_GATE_GROUPS.WITH_INSIDER_GATE_NO_INCENTIVE) {
            dataLayer.push({
                'event': 'appPageView',
                'appPageName': 'home: non-gwp become a coach insider',
                'flowConfig': Util.getGAFlowConfig()
            });
        }
    }

    onBannerSlotClick = () => {
        Util.gotoRoute('/product-categories', this.props.history);
    }

    render() {
        const {
            user,
            firstNameError,
            lastNameError,
            emailError,
            passwordError,
            cPasswordError,
            showPassword,
            showCPassword,
            isBirthdayVisible,
            birthMonth,
            birthDay,
            isBirthdayError,
            emailInUseError,
            invalidFirstName,
            invalidLastName,
            showSignUpOverlay,
            showSignInOverlay,
            isIntroVisible
          } = this.state;
        let home = {};
        let common = {};
        let accountLogin = {};
        let productDetail = {};
        let accountCreate = {};
        let emailSub = {};
        const { isEmailOptIn, locale } = this.props;
        let lang = Util.getSelectedLanguage();
        const dayOptions = this.getDayOptions(birthMonth);
        const storeDetails = Util.getStoreDetails();
        const isLoggedIn = Util.isUserLoggedIn();
        const showAttentiveFloatingWIdget = this.shouldShowAttentiveFloatingWIdget();
        const shouldShowSignUpOverlay = this.insiderGateGroup !== Util.INSIDER_GATE_GROUPS.WITHOUT_INSIDER_GATE &&  
                                        isLoggedIn !== Util.LOGGEDIN_STATUS.LOGGED_IN &&
                                        !isIntroVisible &&
                                        showSignUpOverlay &&
                                        !Util.isECatalogueFlow();

        
        if (this.props.locale && this.props.locale.screens) {
            home = this.props.locale.screens.home;
            common = this.props.locale.screens.common;
            accountLogin = this.props.locale.screens.login;
            productDetail = this.props.locale.screens.productDetail;
            accountCreate = this.props.locale.screens.createAccount;
            emailSub = this.props.locale.screens.emailSub;
    }

       const showTermsContainer = Util.getStringFromStorage(Util.IS_HOME_TERMS_CLOSED) || false;
        let rewardsList = [ {
            image: earlyAccessIcon,
            label: <label /*aria-hidden ={this.state.isRewardExpanded?"false":"true"}*/>{common.earlyAccess}</label>
        },
        {
            image: personalizationIcon,
            label: <label>{home.personalized}<br />{home.offers}</label>
        },
        {
            image: birthdaySurprizeIcon,
            label: <label /*aria-hidden ={this.state.isRewardExpanded?"false":"true"}*/>{home.birthday}<br />{home.rewards}</label>
        },
        // {
        //     image: returnsIcon,
        //     label: <label>{home.easy}<br />{home.returns}</label>
        // },
       
        // {
        //     image: insiderExclusiveIcon,
        //     label: <label /*aria-hidden ={this.state.isRewardExpanded?"false":"true"}*/>{common.insider} {home.exclusive}<br />{home.products}</label>
        // },
        {
            image: giftIcon,
            label: <label /*aria-hidden ={this.state.isRewardExpanded?"false":"true"}*/>{home.giftWith}<br />{home.purchase}</label>
        },
        // {
        //     image: invitationIcon,
        //     label: <label /*aria-hidden ={this.state.isRewardExpanded?"false":"true"}*/>{common.insider}<br />{home.events}</label>
        // },
        // {
        //     image: freeShippingIcon,
        //     label: <label /*aria-hidden ={this.state.isRewardExpanded?"false":"true"}*/>{home.freeShipping}<br />{home.over99}</label>
        // },
        ];

        let tutorialText = [
            <h2 className={'carousel-text ' + lang}>{home.checkPrices}<br/>{home.accessSpecial}<br/>{home.offersAndSeeYour} {home.savingsWhile}<br/>{home.youShop}</h2>,
            <h2 className={'carousel-text ' + lang}>{home.shopStore}<br/>{home.collectionAndPut}<br/>{home.itemsOnHoldBefore}<br/>{home.youEnterTheStore}</h2>,
            <h2 className={'carousel-text ' + lang}>{home.plusBecomeA}<br/>{home.coach}{" "}{<i>in</i>}{home.coachInsiderTo}<br/>{home.unlockExclusive}<br/>{home.accessAndRewards}</h2>
        ]
        let tutorialTextDisabled = [
            <h2 className={'carousel-text ' + lang}>{home.checkPrices}<br/>{home.accessSpecial}<br/>{home.offersAndSeeYour} {home.savingsWhile}<br/>{home.youShop}</h2>,
            <h2 className={'carousel-text ' + lang}>{home.browseStore}<br/>{home.collectionsAndFind}<br/>{home.yourFavoritesBefore}<br/>{home.youEnterTheStore}</h2>,
            <h2 className={'carousel-text ' + lang}>{home.plusBecomeA}<br/>{home.coach}{" "}{<i>in</i>}{home.coachInsiderTo}<br/>{home.unlockExclusive}<br/>{home.accessAndRewards}</h2>
        ]
        if(this.state.isIntroVisible)
        {
        var dots = document.getElementsByClassName('dot')
            if(dots && dots.length){
              for (var i = 0; i < dots.length; i++){
                var hide = document.createAttribute("aria-label");
                hide.value = "Slide"+" "+(i+1);
                dots[i].setAttributeNode(hide);
              }
            }
        }

        //put the config value here
        // storeDetails.config.productDropData = ``;

         this.productDropData = storeDetails.config && 
                                storeDetails.config.productDropData ? 
                                JSON.parse(storeDetails.config.productDropData) : {};
 
        var drops = document.getElementsByClassName('slide selected')
        if(drops && drops.length>1){
            var hide = document.createAttribute("aria-hidden");
            hide.value = "true";
            drops[1].setAttributeNode(hide);
        }
        var intro = document.getElementsByClassName('slider-item')
        if(intro && intro.length>1){
            var hide = document.createAttribute("aria-hidden");
            hide.value = "false";
            intro[0].setAttributeNode(hide);
        }
        var introButton = document.getElementsByClassName('control-arrow control-next')
        if(introButton && introButton.length>0){
            var label = document.createAttribute("aria-label");
            label.value = "Next Slide";
            introButton[0].setAttributeNode(label);
        }
        let navbarItems = [];
        if (this.productDropData && this.productDropData.categories) {
            this.productDropData.categories.forEach(category => {
               if (category.id && category.content && category.content[lang]) {  
                   navbarItems.push({
                    'id': category.id,
                    'value': category.content[lang]
                   });
               }
            });
        }

        if (shouldShowSignUpOverlay || showSignInOverlay || isBirthdayVisible || isIntroVisible) {
            
            if (isIntroVisible) {
                this.disableScroll({ deepLock: false });
            } else {
                this.disableScroll({ deepLock: true });
            }
        } else {
            if (isIntroVisible) {
                this.enableScroll({ deepLock: false });
            } else {
                this.enableScroll({ deepLock: true });
            }
        }

        return (
            <div id="home-screen" className={`home-screen visible ${lang} ${Util.isUserLoggedIn() == Util.LOGGEDIN_STATUS.LOGGED_IN ? "loggedIn" : ""}`}>
                {this.state.isIntroVisible ?
                    <FullScreenModal className={"full-screen-modal-container " + (lang)} showCloseButton={this.insiderGateGroup === Util.INSIDER_GATE_GROUPS.WITHOUT_INSIDER_GATE} onClose={() => this.onIntroModalClose()}>
                        <BannerLogo commonTextData={{}}/>
                        <span className="sub-heading">{home.digitalShoppingAssistant}</span>
                        
                        { this.insiderGateGroup === Util.INSIDER_GATE_GROUPS.WITHOUT_INSIDER_GATE ? 
                        
                            <Carousel
                                className={"promo-content-carousel "+(this.state.lastSlide ? 'lastone': '')}
                                showArrows={true}
                                onChange={(itemIndex) => this.updateCurrentslide(itemIndex, this.state.shopInLineEnabled)}
                                swipeable={true}
                                showStatus={false}
                                showThumbs={false}
                            >
                            {this.state.shopInLineEnabled == true ? 
                            tutorialText.map((item, index) => {
                                return <div aria-hidden="true" className="slider-item" tabIndex={index} key={index}>
                                    {item}
                                </div>;
                            }) 
                            :  
                            tutorialTextDisabled.map((item, index) => {
                                return <div aria-hidden="true" className="slider-item" tabIndex={index} key={index}>
                                    {item}
                                </div>;
                            }) }
                        </Carousel>

                        :
                            
                        <div className='contents-container'>
                            <h2>
                                {home.scanProductTags}
                            </h2>
                            <div className='action-container'>
                                <MainButton
                                    className="black"
                                    text={common.createAccount}
                                    short={true}
                                    onClick={this.onIntroCarouselSignUpClick} />

                                <MainButton
                                    className="line"
                                    text={common.signIn}
                                    short={true}
                                    onClick={this.onIntroCarouselSignInClick} />
                            </div>
                        </div>

                        }

                    </FullScreenModal>:''
                }
                {this.state.isAttentivePopUpVisible ?
                    <CommonModal className={!this.state.optInSuccessful?`hold-item-form-modal ${lang}`:" success-item-form-modal "} onClose={() => this.onAttentivePopupCloseClick()} >
                        {!this.state.optInSuccessful ?
                            <div className="attentive-container">
                                <div className="sign-up-text">
                                    <span className="promo">{home.attentiveOfferText}</span>
                                </div>
                                <span className={this.state.optInValidation ? "main-error visible" : "main-error"}>{this.state.optInValidation}</span>
                                <div className="input-form-container">
                                    <MainInput
                                        type="email"
                                        placeholder={accountLogin.emailPlaceholder}
                                        //   value={holdRequestName}
                                        onChange={(event) => this.onChangeInput('atttentiveEmail', event.target.value)}
                                        id="email-address"
                                        maxLength="32"
                                        className={(this.state.validationMessageEmail ? 'coach-input has-error': 'coach-input')} 
                                    />
                                    <span className={this.state.validationMessageEmail ? "error visible" : "error"}>{this.state.validationMessageEmail}</span>
                                    <NumberFormat
                                        id="hold-request-phone"
                                        format="(###) ###-####"
                                        type="text"
                                        placeholder={common.MobileNumber}
                                        //   value={holdRequestPhone}
                                        onChange={(event) => this.onChangeInput('attentivePhone', event.target.value)}
                                        className={"coach-input "+(this.state.validationMessagePhone ? 'has-error': '')}
                                        
                                    />
                                    <span className={this.state.validationMessagePhone ? "error visible" : "error"}>{this.state.validationMessagePhone}</span>
                                </div>
                                <div className="terms"> {common.optInTermsAndPrivacy} <a target='_blank' href='https://www.coachoutlet.com/privacy.html' onClick={this.onPrivacyPolicyClick} aria-describedby='new-window-0'> {common.optInPrivacyPolicy}. <span hidden>opens in a new window</span></a> {common.emailOptInDesclaimer2}</div>
                                <div className="action-container">
                                    <MainButton
                                        className="black"
                                        text={common.signUp}
                                        short={true}
                                        onClick={this.signUpAlerts.bind(this)}
                                    />
                                </div>
                            </div>
                            :
                            <div className="attentive-success">
                                <img alt="" className="successCheck" src={successCheck} />
                                <span className="checkText">{common.checkText}</span>
                            </div>
                        }
                    </CommonModal> : ''
                }
                {!shouldShowSignUpOverlay && !isBirthdayVisible ? "" :
                    <div className= "outerOverlay">
                        {!isBirthdayVisible ? (
                            <>

                                <CommonModal className="membershipOverlay">
                                    <div className="header-container">
                                        <div aria-level="1" role="heading" tabIndex="0" aria-label={lang == 'en-us' ? common.becomeA + " " + common.coach + " " + common.in + common.siderWithoutExclamation : common.becomeACoachInsider} className="title-container">
                                            {lang == 'en-us' ?  //since English some parts needs to in italics and others don't
                                                <>
                                                    <span aria-hidden="true" className="title">{common.becomeA}</span>
                                                    <span aria-hidden="true" className="title">{common.coach} <i>{common.in}</i>{common.siderWithoutExclamation}</span>
                                                </>
                                                : <span aria-hidden="true" className="title">{common.becomeACoachInsider}</span>
                                            }

                                        </div>
                                        <span className="subPromo">
                                            {this.insiderGateGroup === Util.INSIDER_GATE_GROUPS.WITH_INSIDER_GATE_AND_INCENTIVE ?
                                                <div>Sign-up and check-out with the Digital Shopping <br /> Assistant to receive a free gift with purchase!</div> :
                                                <div>Sign-up to get access to your exclusive <br /> insider benefits!</div>
                                            }
                                        </span>
                                        <div className="rewardsBox">
                                            <div className="rewardsIcon">
                                                <img alt="" className="" src={watch} />
                                                <span>Early Access </span>
                                            </div>
                                            <hr />
                                            <div className="rewardsIcon" >
                                                <img alt="" className="" src={offersIcon} />
                                                <span>Personalized Offers </span>
                                            </div>
                                            <hr />
                                            <div className="rewardsIcon">
                                                <img alt="" className="" src={birthdayIcon} />
                                                <span>Birthday rewards</span>
                                            </div>
                                            <hr />
                                            <div className="rewardsIcon">
                                                <img alt="" className="infinite" src={infinite} />
                                                <span>and many more.. </span>
                                            </div>
                                        </div>
                                    </div>
                                    <section className="body-section">
                                        <div className="title">
                                            <label className="heading">
                                                {/* no value as its empty */}
                                            </label>
                                            {/* <label className="hint">{accountCreate.required}</label> */}
                                        </div>
                                        <div className="form-group">
                                            <div alt="" className="float-label">
                                                <label className={user.first_name ? "available" : ""} htmlFor={accountCreate.firstName}>{accountCreate.firstName + " (Required)"}</label>
                                                <input
                                                    type="text"
                                                    className={firstNameError || invalidFirstName ? "error" : ""}
                                                    // placeholder={accountCreate.firstName + "*"}
                                                    value={user.first_name}
                                                    onBlur={this.validateField.bind(this, "first_name")}
                                                    onChange={this.onInputChange.bind(this, "first_name")}
                                                    maxLength="16"
                                                />
                                            </div>

                                            {firstNameError ? (
                                                <div className="error-wrapper">
                                                    <ErrorMessage
                                                        label={accountCreate.enterFirstName}
                                                        show={firstNameError}
                                                    />
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                            {this.state.invalidFirstName ? (
                                                <div className="error-wrapper">
                                                    <ErrorMessage
                                                        label={accountCreate.enterValidFname}
                                                        show="true"
                                                    />
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                            <div alt="" className="float-label">
                                                <label className={user.last_name ? "available" : ""} htmlFor={accountCreate.lastName}>{accountCreate.lastName + " (Required)"}</label>
                                                <input
                                                    type="text"
                                                    className={lastNameError || invalidLastName ? "error" : ""}
                                                    // placeholder={accountCreate.lastName + "*"}
                                                    value={user.last_name}
                                                    onBlur={this.validateField.bind(this, "last_name")}
                                                    onChange={this.onInputChange.bind(this, "last_name")}
                                                    maxLength="16"
                                                />
                                            </div>
                                            {lastNameError ? (
                                                <div className="error-wrapper">
                                                    <ErrorMessage
                                                        label={accountCreate.enterLastName}
                                                        show={lastNameError}
                                                    />
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                            {this.state.invalidLastName ? (
                                                <div className="error-wrapper">
                                                    <ErrorMessage
                                                        label={accountCreate.enterValidSname}
                                                        show="true"
                                                    />
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                            <div alt="" className="float-label">
                                                <label className={user.email ? "available" : ""} htmlFor={accountCreate.emailAddress}>{accountCreate.emailAddress + " (Required)"}</label>
                                                <input
                                                    type="email"
                                                    className={emailError || emailInUseError ? "error" : ""}
                                                    // placeholder={accountCreate.emailAddress + "*"}
                                                    value={user.email}
                                                    onBlur={this.validateField.bind(this, "email")}
                                                    onChange={this.onInputChange.bind(this, "email")}
                                                    maxLength="40"
                                                />
                                            </div>
                                            {emailError ? (
                                                <div className="error-wrapper">
                                                    <ErrorMessage
                                                        label={this.getErrorLabels(emailError)}
                                                        show={emailError}
                                                    />
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                            <div className="input-wrapper">

                                                <div alt="" className="float-label">
                                                    <img
                                                        role="button"
                                                        aria-label={showPassword ? "Hide Password" : "show Password"}
                                                        src={showPassword ? passwordDontShowEye : showPasswordEye}
                                                        onClick={this.onEyeClick.bind(this, "password")}
                                                    />
                                                    <label className={user.password ? "available" : ""} htmlFor={accountCreate.password}>{accountCreate.password + " (Required)"}</label>
                                                    <input
                                                        type={showPassword ? "text" : "password"}
                                                        className={passwordError ? "error" : ""}
                                                        // placeholder={accountCreate.password + "*"}
                                                        value={user.password}
                                                        onBlur={this.validateField.bind(this, "password")}
                                                        onChange={this.onInputChange.bind(this, "password")}
                                                        onFocus={this.passwordFieldOnFocus}
                                                        maxLength="40"
                                                    />
                                                </div>
                                            </div>
                                            {passwordError &&
                                                passwordError != ERROR_LABELS.PASSWORD.MISMATCH ? (
                                                <div className="error-wrapper">
                                                    <ErrorMessage
                                                        label={this.getErrorLabels(passwordError)}
                                                        show={
                                                            passwordError &&
                                                            passwordError != ERROR_LABELS.PASSWORD.MISMATCH
                                                        }
                                                    />
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                            {/* <div className="input-wrapper">
                  <img
                    src={showCPassword ? passwordDontShowEye :showPasswordEye }
                    onClick={this.onEyeClick.bind(this, "cpassword")}
                  />
                  <input
                    type={showCPassword ? "text" : "password"}
                    className={cPasswordError ? "error" : ""}
                    placeholder="Confirm Password*"
                    value={user.cpassword}
                    onBlur={this.validateField.bind(this, "cpassword")}
                    onChange={this.onInputChange.bind(this, "cpassword")}
                  />
                </div> */}
                                            {/* {cPasswordError ? (
                  <div className="error-wrapper">
                    <ErrorMessage
                      label={this.getErrorLabels(cPasswordError)}
                      show={cPasswordError}
                    />
                  </div>
                ) : (
                  ""
                )} */}

                                            {this.state.showPasswodHint ? (
                                                <div tabIndex="0" aria-live="assertive" role="alert" aria-atomic="true" className="privacy-container">
                                                    {accountCreate.passwordHint}
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                        </div>

                                    </section>
                                    <section className="password-section">
                                        <div className="privacy-container">
                                            <SquareCheckbox
                                                checked={isEmailOptIn}
                                                label={""}
                                                //ariaLabel ={common.emailOptInDesclaimer+" "+accountCreate.privacyPolicy+" "+emailSub.contactUsLink+" "+common.emailOptInDesclaimer2}
                                                click={this.onChangeAgreeTermsChackbox.bind(this)}
                                            />
                                            <div className="opt-in-container">
                                                &nbsp;{common.emailOptInDesclaimer}
                                                &nbsp;<a target='_blank' href='https://www.coachoutlet.com/privacy.html' onClick={this.privacyPolicyLink} aria-describedby='new-window-0'> {accountCreate.privacyPolicy} <span hidden>opens in a new window</span></a>&nbsp;  or  &nbsp;<a target='_blank' href='https://www.coachoutlet.com/emailus?ctid=contact-us' onClick={this.contactUsLink} aria-describedby='new-window-0'> {emailSub.contactUsLink} <span hidden>opens in a new window</span></a>&nbsp;
                                                {common.emailOptInDesclaimer2}
                                                {/* <span
                    className=""
                    dangerouslySetInnerHTML={{
                      __html: common.emailOptInDesclaimer
                    }}
                  ></span> */}
                                            </div>
                                        </div>
                                    </section>
                                    <section className="create-section">
                                        <MainButton
                                            text={common.createAccount}
                                            disabled={this.isCreateAccountDisabled()}
                                            onClick={this.onCreateAccount.bind(this)}
                                        />
                                        {emailInUseError ? (
                                            <div className="error-wrapper">
                                                <ErrorMessage
                                                    label={this.getErrorLabels(emailInUseError)}
                                                    show={emailInUseError}
                                                    style={{
                                                        lineHeight: "1.88",
                                                        textAlign: "center",
                                                        display: "inline-block",
                                                        marginTop: "10px"
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                    </section>
                                    <section className="login-section">
                                        <div className="login-wrapper">
                                            <span>{common.alreadyHaveAnAccount}</span>
                                            <MainLink onClick={this.onSignUpOverlaySignInClick}>
                                                {accountCreate.login}
                                            </MainLink>
                                        </div>
                                    </section>
                                    <section>
                                        <div className="disclaimer-container">
                                            {accountCreate.disclaimer}
                                            <a target='_blank' href='https://www.coachoutlet.com/privacy.html' onClick={this.privacyPolicyLink} aria-describedby='new-window-0'> {accountCreate.privacyPolicy} </a>
                                            {accountCreate.disclaimer2}
                                            {/* <span
                  className=""
                  dangerouslySetInnerHTML={{
                    __html: accountCreate.disclaimer
                  }}
                ></span> */}
                                        </div>
                                    </section>
                                </CommonModal>
                            </>
                        ) : (
                            <>
                                <div className="birthday-container">
                                    <img src={closeImage} aria-label="Close this page" onClick={this.onSkipBirthday.bind(this)} />
                                    <span className="title">{accountCreate.couldWeGet}</span>
                                    <span className="title">{accountCreate.yourBirthday}</span>
                                    <div className="info-container">
                                        <span className="info">{accountCreate.youCantChangeBday}</span>
                                        <span className="info">{accountCreate.youCanAddLater}</span>
                                    </div>
                                    <div className="date-select-container">
                                        <div className="arrow"></div>
                                        <div className="arrow right"></div>
                                        <select
                                            className={
                                                "month " + (isBirthdayError && !birthMonth ? "error" : "")
                                            }
                                            placeholder={accountCreate.month}
                                            onChange={this.onSelectMonthDateChange.bind(this, "month")}
                                            value={this.state.birthMonth}
                                        >
                                            <option value="">{accountCreate.month}</option>
                                            {Util.MONTH_DATE.map((monthObj, index) => {
                                                return (
                                                    <option
                                                        key={"month-" + index}
                                                        value={monthObj.monthValue}
                                                    >
                                                        {monthObj.translations[lang]}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                        <select
                                            className={
                                                "date " + (isBirthdayError && !birthDay ? "error" : "")
                                            }
                                            placeholder={accountCreate.day}
                                            onChange={this.onSelectMonthDateChange.bind(this, "day")}
                                            value={this.state.birthDay}
                                        >
                                            <option value="">{accountCreate.day}</option>
                                            {dayOptions}
                                        </select>
                                    </div>
                                    {this.state.isBirthdayError ? (
                                        <ErrorMessage
                                            label={accountCreate.selectMonthDay}
                                            show="true"
                                        />
                                    ) : (
                                        ""
                                    )}

                                    <div className="action-container">
                                        <MainButton
                                            className={!this.isBirthdayValid() ? "disabled" : ""}
                                            text={accountCreate.saveBirthday}
                                            onClick={this.onSaveBirthDay.bind(this)}
                                        />
                                    </div>
                                    <MainLink onClick={this.onSkipBirthday.bind(this)}>
                                        {accountCreate.maybeLater}
                                    </MainLink>
                                </div>
                            </>
                        )}
                    </div>
                }
                {this.state.isTermsVisible ?
                    <FullScreenModal tabIndex='0' aria-live="polite" className="termsofuse" onClose={() => this.toggleTermsOfUseModal(false)}>
                        <div className="terms-content">
                            <h2>{common.termsAndConditions}</h2>
                            <p>
                            {common.fullDesclaimerNew}
                                <a target='_blank' href='https://www.coachoutlet.com/terms-of-use.html' onClick={this.onTermsOfUseClick} aria-describedby='new-window-0'> {common.termsOfUse} <span hidden>opens in a new window</span></a> {common.and} <a target='_blank' href='https://www.coachoutlet.com/privacy.html' onClick={this.onPrivacyPolicyClick} aria-describedby='new-window-0'> {common.privacyPolicy} <span hidden>opens in a new window</span></a> {common.fullDisclaimerPost}
                                {common.fullDesclaimerNew2}
                                {common.fullDesclaimerNew3}
                            </p>
                        </div>
                    </FullScreenModal>:''
                }
               
               { showSignInOverlay && <SignInOverlay onSignInSuccess={this.onSignInOverlaySignInSuccess} onSignUpClick={this.onSignInOverlaySignUpClick} /> }

                {Util.isUserLoggedIn() != Util.LOGGEDIN_STATUS.LOGGED_IN && !showTermsContainer ?
                    <div aria-hidden={this.state.isIntroVisible?"true":"false"} className="top-info-container tc">
                        <label className={lang}>{common.byUsingThisApp}<MainLink onClick={this.toggleTermsOfUseModal.bind(this)}>{common.termsOfUse}</MainLink></label>
                        <img tabIndex="0" role="button" src={closeIcon} className="close" onClick={this.hideTermsContainer}/>
                    </div>:''
                }
                <div aria-hidden={this.state.isIntroVisible?"true":"false"} className="heading-name"><h1 className={lang}>{home.yourDigitalShoppingAssistant}</h1></div>
                <div aria-hidden={this.state.isIntroVisible?"true":"false"}  className="top-info-container extra-padding">
                    <span className={lang}>{home.scanAndCheckPrice}</span>
                    <div className="action-container">
                        <MainButton
                            className="black"
                            text={common.scanAProduct}
                            short={1}
                            type="line"
                            onClick={this.openScanWindow.bind(
                                this,
                                Util.SCANNER_PRODUCT_TYPE
                            )}
                        />
                    </div>
                </div>
                {/* <div aria-hidden={this.state.isIntroVisible?"true":"false"} className={"coach-ar-tile " + (!this.peanutARExperienceEnabled ? "disabled" : "")} id='ar-parent-element'  onClick={this.onARBannerClick}>
                    <div className='ar-banner-content' ref={this.ARSlotRef}>
                        <span className='top-secton'> {home.peanutsSlotMainContent} </span>
                        <span className='bottom-section cta'> {home.peanutsSlotSubContent} </span>
                        <div className='disclaimer'> {home.peanutsDisclaimer}<a href={ARUtil.REDIRECTION_LINK} target='_blank' onClick={this.onARBannerDisclaimerLinkClick} > www.coachoutlet.com/peanutsweeps.</a> </div>
                    </div>
                    <img alt="" className="ar-image" src={arBanner} />
                </div> */}

                { this.ARExperienceEnabled && <ARSlot {...this.ARSettings} /> }  

                <div aria-hidden={this.state.isIntroVisible ? "true" : "false"} className="coach-insider-tile">
                    <img src={homePageSlotBanner} style={{ width: "100%" }} border="0" alt='give them something extra special' />
                    <button onClick={this.onBannerSlotClick} style={{ backgroundColor: "transparent", width: "24%", height: "8%", position: "absolute", top: "47%", border: "none" }} />
                </div>

                 <div aria-hidden={this.state.isIntroVisible ? "true" : "false"} className="coach-insider-tile">
                    {Util.isUserLoggedIn() != Util.LOGGEDIN_STATUS.LOGGED_IN ?
                        <>
                            <button onClick={this.onSignUpImageMap.bind(this, true)} style={{ backgroundColor: "transparent", width: "30%", height: "6%", position: "absolute", top: "85%", border: "none" }}></button>
                            <button onClick={this.onSignUpImageMap.bind(this, false)} style={{ backgroundColor: "transparent", width: "12%", height: "2%", position: "absolute", top: "93%", left: "65%", border: "none" }}></button>
                            <img src={dsaInsider} style={{ width: "100%" }} border="0" />
                        </>
                        :
                        <> 
                            {/* <button onClick={this.onSignUpImageMap.bind(this, true)} style={{ backgroundColor: "transparent", width: "30%", height: "6%", position: "absolute", top: "85%", border: "none" }}></button>
                            <button onClick={this.onSignUpImageMap.bind(this, false)} style={{ backgroundColor: "transparent", width: "12%", height: "2%", position: "absolute", top: "93%", left: "65%", border: "none" }}></button> */}
                            <img src={dsaLoggedInInsider} style={{ width: "100%" }} border="0" />
                        </>
                    } 



                    {/* {Util.isUserLoggedIn() != Util.LOGGEDIN_STATUS.LOGGED_IN ?
                        <>
                            <div tabIndex="0" aria-level="1" role="heading" aria-label={common.becomeA +" "+ common.coach +" "+ common.in + common.siderWithoutExclamation}>
                                <h2 aria-hidden="true">{common.becomeA} <br /> {common.coach} <i>{common.in}</i>{common.siderWithoutExclamation}</h2>
                            </div>
                                <span>{common.getInsideAccess}</span>
                        </>:
                        <>
                            <h2>{home.seeWhatsNew}</h2>
                            <span>{home.yourFirstLookAtTheLatestFrom}<br/>{home.coachOutletDropped}</span>
                        </>
                    }
                    <div className="image-container">
                        <div className="rewardIcons">
                        {rewardsList.map((item, index) => {
                                return <div className="list-item" key={index}>
                                    <img alt="" src={item.image} />
                                    {item.label}
                                </div>
                            })}
                        </div>
                        <div>
                            <img alt="" className="insiderImge" src={Util.isUserLoggedIn() == Util.LOGGEDIN_STATUS.LOGGED_IN ? insiderImageLoggedIn : insiderImage} />
                        </div>
                    </div>
                    {Util.isUserLoggedIn() != Util.LOGGEDIN_STATUS.LOGGED_IN ?
                        <div className="action-container user-session">
                            <MainButton type="line" text={common.becomeInsider} onClick={this.onAccountLinkClick.bind(this, 'account/create')} short={1}/>
                            <span className="small">{common.alreadyHaveAnAccount} <MainLink onClick={this.onAccountLinkClick.bind(this, 'account/login')}>{common.signInCapitalized}</MainLink></span>
                        </div>:''
                    } */}
                 </div> 
                {/* <div aria-hidden={this.state.isIntroVisible?"true":"false"} className="coach-insider-tile rewards">
                    <div className={"rewards-list-container "+lang+" "+(this.state.isRewardExpanded ? 'expanded': '')}>
                    <div tabIndex="0" aria-level="2" role="heading" aria-label={common.in + common.siderWithoutExclamation +" "+ home.rewards}>
                        <h2 aria-hidden="true"><i>{common.in}</i>{common.siderWithoutExclamation} {home.rewards}</h2>
                    </div>
                        <div className="rewards-list">
                            {rewardsList.map((item, index) => {
                                return <div className="list-item" key={index}>
                                    <img alt="" src={item.image} />
                                    {item.label}
                                </div>
                            })}
                        </div> */}
                        {/* <div className="action-container">
                            <MainLink
                                className="feedback-link"
                                onClick={this.onToggleExpandRewards.bind(this)}
                            >   
                                {this.state.isRewardExpanded ? home.viewLess:home.viewMore}
                            </MainLink>
                        </div> */}
                    {/* </div>
                </div> */}
                <div aria-hidden={this.state.isIntroVisible?"true":"false"} className="browse-container">
                        <span className={lang}>{home.waitingInLine}</span>
                        <MainButton
                            className="black"
                            text={home.shopTheStore}
                            short={1}
                            type="line"
                            onClick={this.onBrowseClick.bind(this)}
                        />
                </div>

                {/* <div className="product-grid">
                    <img src={productGrid} />
                </div> */}

                {/* <div className='coach-insider-tile ar'>
                    <div id="arlene-root" data-key="9IZJJygKGtHUyatw5rr8Ud1EyHKvEC4161I6pz2fvYwY4SCDi6nE2oixGDMDKNghutlEKP"></div>
                </div> */}

                <div aria-hidden={this.state.isIntroVisible?"true":"false"} className="coach-insider-tile exclusive">
                    <div tabIndex="0" aria-level="2" role="heading" aria-label={common.in + common.siderWithoutExclamation +" "+ home.exclusiveDrops}>
                    <h2 aria-hidden="true"><i>{common.in}</i>{common.siderWithoutExclamation}<br />{home.exclusiveDrops}</h2>
                    </div>
                    <span style={{marginBottom: '20px'}}>{common.coach} {common.insiders} {home.getSpecialAccess}<br/>{home.toNewStyleDrops}</span>

                    {
                        navbarItems &&
                        navbarItems.length ? 
                            <MiniNavbar 
                                selectedItem={this.state.productDropSelectedCategory || navbarItems[0].id}
                                onClickItem={(index) => this.onNavbarItemClick(index)}
                                items={navbarItems} />
                            : ''
                    }
                    
                    <div id="exclusive-image-carousel" className="carousel-container">

                    <div 
                        onTouchStart={(touchStartEvent) => this.onProductDropCarouselSwipeStart(touchStartEvent)}
                        onTouchMove={(touchMoveEvent) => this.onProductDropCarouselSwipeMove(touchMoveEvent.changedTouches[0])}
                        onTouchEnd={(touchMoveEvent) => this.onProductDropCarouselSwipeEnd(touchMoveEvent.changedTouches[0].screenX)} >
                    <Carousel
                        className="exclusive-image-carousel"
                        showArrows={false}
                        showStatus={false}
                        showThumbs={false}
                        infiniteLoop={true}
                        centerMode={true}
                        centerSlidePercentage={80}
                        swipeable={false}
                        onChange={itemIndex => this.onProductDropCarouselItemChange(itemIndex)}
                        selectedItem={this.state.productDropCarouselSelectedItemIndex}
                    
                    >
                        {
                            this.productDropData && 
                            this.productDropData.slides &&
                            this.productDropData.slides.length ?

                                // this.productDropData.slides.reduce((acc, curr, index) => {
                                    
                                //     if (curr.category === this.state.productDropSelectedCategory) {
                                //         acc.push(<ProductDropCard data={curr} key={index} position={index} 
                                //             selectedIndex={this.state.productDropCarouselSelectedItemIndex}/>);
                                //     }
                                //     return acc;     
                                // }, [])

                                this.productDropData.slides.map((PDData, index) => {
                                     
                                    return <ProductDropCard data={PDData} key={index} position={index} 
                                                selectedIndex={this.state.productDropCarouselSelectedItemIndex}/>;                                    
                                })

                            : ''
                        }
                        
                    </Carousel>
                    </div>
                    </div>

                    <div aria-hidden="true" className="floating-button" 
                            onClick={this.state.floatingLabelAnimation == "floatingLabelFadeIn" ? 
                            this.onFloatingLabelClick : () => {}}
                            style={{animationName: this.state.floatingLabelAnimation}}>
                            <div className="c1">
                                <span>{common.scanAProduct}</span>
                                <div className="c2">
                                </div>
                            </div>
                        </div>

                    {/* <div className="action-container feedback">
                        <div className="label">{common.feedbackInfo}</div>
                        <MainLink
                            className="feedback-link"
                            onClick={this.onFeedbackClick.bind(this, 'link')}
                        >
                            {common.feedbackLink1}
                        </MainLink>
                    </div> */}

                    {
                        showAttentiveFloatingWIdget && 
                            <FloatingWidget bodyText={home.attentiveOfferText} ctaText={common.signUp} 
                                ctaCallback={this.onFloatingWidgetCtaClick} enableCloseButton={true} onCloseButtonClick={this.onFloatingWidgetClose}
                                variants={floatingWidgetVariant.variants}
                                initial={floatingWidgetVariant.variantTypes.FADE_IN, floatingWidgetVariant.moveUp}
                                animate={this.state.floatingLabelAnimation === 'floatingLabelHide' || this.state.floatingLabelAnimation === 'floatingLabelFadeOut' ? floatingWidgetVariant.moveDown : floatingWidgetVariant.moveUp}
                                exit={floatingWidgetVariant.variantTypes.FADE_OUT}  />
                    }
                </div>
            </div>
        );
    }

    onFloatingWidgetCtaClick = () => {
        dataLayer.push({
            'event': 'attentiveInteraction',
            'eventAction': 'attentive banner click',
            'eventLabel': 'sign up'
        });
        this.setState({showFloatingWidget: false});
        this.onClickAttentive();
    }

    onFloatingWidgetClose = () => {
        this.setState({showFloatingWidget: false});
        Util.addStringToStorage(Util.SHOW_ATTENTIVE_FLOATING_POPUP, 'false');
    }

    onWindowScroll = () => {

        if (this.productDropData && 
            this.productDropData.slides &&
            this.productDropData.slides.length) {

                
                let h = document.getElementsByClassName("dot");
                
                this.productDropData.slides.forEach((currentProductDropData, index) => {

                    let h1Attrib = document.createAttribute("aria-label");
                    h1Attrib.value = `Slide ${index + 1} ${currentProductDropData.name}`;
                    h[index].setAttributeNode(h1Attrib);
                });
              
            const productDropElement = document.getElementById('exclusive-image-carousel');
            const isVisible = Util.isScrolledIntoView(productDropElement);
            if(isVisible && !this.state.isPromotionImpression)
            {
                this.setState({isPromotionImpression:true})

                let productDropPromotions = [];
                this.productDropData.slides.forEach((productDropData, index) => {
                    
                    productDropPromotions.push({
                        id: productDropData.name,
                        name: productDropData.name,
                        creative: productDropData.creative,
                        position: index + 1
                    });
                });

                dataLayer.push({
                    'event': 'promotionImpression',
                    'location': 'home',
                    'ecommerce': {
                        'promoView': {
                            'promotions': productDropPromotions
                        } 
                    }
                });
          }
        }

        this.checkAndFireARSlotImpressionEvent();
        
    }

    checkAndFireARSlotImpressionEvent = () => {
        if (this.ARSettings.enabled && !this.ARSlotImpressionEventFired) {
            if (this.ARSettings && this.ARSettings.analytics && this.ARSettings.analytics.impression) {
                const ARElement = document.getElementById(ARUtil.AR_SLOT_ELEMENT_ID);
                if (ARElement) {
                    const isARSlotInViewPort = Util.isScrolledIntoView(ARElement);
                    if (isARSlotInViewPort) {
                        dataLayer.push(this.ARSettings.analytics.impression);
                        this.ARSlotImpressionEventFired = true;
                    }
                }
            }
        }
    }

    updateCurrentslide = (index, isShopInlineEnabled) => {
        var drops = document.getElementsByClassName('slider-item')
        if(drops && drops.length>1){
            for (var i = 0; i < drops.length; i++){
                var hide = document.createAttribute("aria-hidden");
                if (index == i) {
                    hide.value = "false";
                } else {
                    hide.value = "true";
                }
                drops[i].setAttributeNode(hide);
              }
           
        }

        if (index==0) {
            dataLayer.push({
                'event': 'appPageView',
                'appPageName': 'intro: check price and savings',
                'flowConfig': Util.getGAFlowConfig()
            });
        } else if(index==1){
            dataLayer.push({
                'event': 'appPageView',
                'appPageName': (isShopInlineEnabled == true ? 
                        'intro: shop store collection and put items on hold' :
                        'intro: waiting inline? browse and put items on hold'),
                'flowConfig': Util.getGAFlowConfig()
            });
        }    
        else{
            dataLayer.push({
                'event': 'appPageView',
                'appPageName': 'intro: become a coach insider',
                'flowConfig': Util.getGAFlowConfig()
            }); 
        }

        // for showing home screen on over swipe
        if (index == this.state.carouselTotalItemsCount && index == this.carouselPrevItemPosition) {
                document.body.style.overflow = 'unset';
                this.setState({isIntroVisible: false});
                this.bottombartoggle(false)   
   

        }
                 
        this.carouselPrevItemPosition = index;
        
        var introButton = document.getElementsByClassName('control-arrow control-next')
        if(introButton && introButton.length>0)
        {
        if(index>=0 && index<2){
            var label = document.createAttribute("aria-label");
            label.value = "Next Slide";
            introButton[0].setAttributeNode(label);
        }
        else{
            var label = document.createAttribute("aria-label");
            label.value = "Get Started";
            introButton[0].setAttributeNode(label);
        }
    }

        
    }
    onAccountLinkClick(route) {
        let queryParam = "";

        if (route.indexOf('account/login') > -1){
        dataLayer.push({
            event: "membershipInteraction",
            membershipEventType:'login',
            membershipEventLocation: "membership module",
            membershipEventCTA:'Sign In',
            membershipEventAction:'click',
            membershipEventTitle:'login',
          })
          queryParam = "?source=membership_module";
        }
        else{
            dataLayer.push({
                event: "membershipInteraction",
                membershipEventTitle:'signup',
                membershipEventType:'signup',
                membershipEventCTA:'BECOME AN INSIDER',
                membershipEventLocation:"membership module",
                membershipEventAction:'click',
              })
              queryParam = "?source=membership_module";
        }
        Util.gotoRoute(route + queryParam, this.props.history);
    }
    onToggleExpandRewards() {
        this.setState({isRewardExpanded: !this.state.isRewardExpanded});
    }
    toggleTermsOfUseModal() {
        this.setState({isTermsVisible: !this.state.isTermsVisible});
    }
    bottombartoggle(hide){
        var bottomBar = document.getElementsByClassName('bottom-navigation-bar')
        var bar = document.createAttribute("aria-hidden");
        if(hide){
            bar.value = "true";
         }
        else{
            bar.value = "false";
         }
        bottomBar[0].setAttributeNode(bar); 
    }
    toggleIntroModalVisibility(isVisible = true, callback = () => {}) {
        const isShown = Util.getStringFromStorage(Util.INTRO_CAROUSEL_SHOWN) || '';
        if (isVisible && (!isShown || isShown == 'false')) {
            this.bottombartoggle(true)   
            this.setState({isIntroVisible: isVisible}, () => {

                Util.addStringToStorage(Util.INTRO_CAROUSEL_SHOWN, "true");
                document.body.style.overflow = 'hidden';
                callback();
            });
        } else {

            document.body.style.overflow = 'unset';
            if (!isVisible) {
                this.bottombartoggle(false)   
                this.setState({isIntroVisible: isVisible}, () => {
                    callback();
            });
        }
        }

        this.setState({isHomePage: isVisible})

    }

    enableScroll = ({ deepLock = false }) => {

        //pass deepLock = true for the interactions which will have keypad open (eg. text input) to avoid issues with Safari

        document.body.style.overflow = 'unset';
        // if (deepLock) {
        //     const rootElement = document.querySelector('.home-screen');
        //     if (rootElement) {
        //         rootElement.removeEventListener('touchmove', this.preventTouchMoveDefault);
        //     }
        // }
    }
    
    disableScroll = ({ deepLock = false }) => {
        document.body.style.overflow = 'hidden';
        // if (deepLock) {
            // const rootElement = document.querySelector('.home-screen');
            // if (rootElement) {
            //     rootElement.addEventListener('touchmove', this.preventTouchMoveDefault, { passive: false });
            // }
        // }
    }

    preventTouchMoveDefault = (e) => {
        e.preventDefault();
    }

    onFeedbackClick(from) {
        if (from === 'link') {
          dataLayer.push({
              'event': 'giveFeedback',
              'giveFeedbackAction': 'give feedback click',
              'giveFeedbackLocation':'Home',
              'flowConfig': Util.getGAFlowConfig(),
          });
        } else if (from === 'tab') {
          dataLayer.push({
              'event': 'giveFeedback',
              'giveFeedbackAction': 'feedback tab click',
              'giveFeedbackLocation':'Home',
              'flowConfig': Util.getGAFlowConfig(),
          });
        }
        const storeDetails = Util.getStoreDetails();
        let common = {};
        if (this.props.locale && this.props.locale.screens) {
          common = this.props.locale.screens.common;
        }
        if (
          confirm(common.leavePageConfirmation) &&
          storeDetails &&
          storeDetails.config &&
          storeDetails.config.surveyLink
        ) {
          let link = storeDetails.config.surveyLink;
          link = link.replace('{?}', storeDetails.storeId);
          window.open(link, "_blank");
        }
    }
    onBrowseClick() {
        dataLayer.push({
            'event': 'requestInLine',
            'moduleText': 'Browse Collections',
            'moduleTitle': "Shop Before You Enter",
            eventCallback: () => {
                Util.gotoRoute('/product-categories', this.props.history);
            },
            eventTimeout: 2000
            });
    }
    openScanWindow(type = Util.SCANNER_PRODUCT_TYPE, event) {
        let action;
        if (type == Util.SCANNER_PRODUCT_TYPE) {
          action = "scan item click";
        } else {
          action = "scan offer click";
        }
        dataLayer.push({
            event: "dataLayer-initialized",
            customAttributes:Util.getCustomAttributes(),
            userID: Util.getEmailId(),
            language: Util.getSelectedLanguage(),
            pageName: "barcode scanner",
            pageType: "barcode scanner",
            storeID: Util.getStoreDetails().storeId,
            storeDesc: Util.getStoreDetails().name,
            flowConfig: Util.getGAFlowConfig(),
            signedIn: (Util.isUserLoggedIn() == Util.LOGGEDIN_STATUS.LOGGED_IN) ? 'signed-in user' : 'guest'
          });
        dataLayer.push({
            event: "barcodeScanningInteraction",
            barcodeAction: action,
            barcodeScanCTALocation: "Top Scan Product",
            barcodeScanCTA:'Scan a Product',
           
            "eventCallback": () => {
              window.toggleBarcodeScanner(true, type);
            },
            "eventTimeout": 2000,
          });
      }

    isScrollReachedBottom = () => (window.innerHeight + window.scrollY || window.pageYOffset) 
                                    >= document.body.offsetHeight;


    onSignUpImageMap(isSignUp) {
        if (Util.isUserLoggedIn() != Util.LOGGEDIN_STATUS.LOGGED_IN) {
            if (isSignUp) {
                Util.gotoRoute("/account/create", this.props.history);
            }
            else Util.gotoRoute("/account/login", this.props.history);
        }
    }
    contactUsLink() {
        dataLayer.push({
            'event': 'outboundLink',
            'linkAction': 'Contact Us'
        });
    }
    privacyPolicyLink() {
        dataLayer.push({
            'event': 'outboundLink',
            'linkAction': 'Privacy Policy'
        });
    }
    onFeedbackClick(from) {
        if (from === 'link') {
            dataLayer.push({
                'event': 'giveFeedback',
                'giveFeedbackAction': 'give feedback click',
                'giveFeedbackLocation': 'create account',
                'flowConfig': Util.getGAFlowConfig(),
            });
        } else if (from === 'tab') {
            dataLayer.push({
                'event': 'giveFeedback',
                'giveFeedbackAction': 'feedback tab click',
                'giveFeedbackLocation': 'create account',
                'flowConfig': Util.getGAFlowConfig(),
            });
        }
        const storeDetails = Util.getStoreDetails();
        let common = {};
        if (this.props.locale && this.props.locale.screens) {
            common = this.props.locale.screens.common;
        }
        if (
            confirm(common.leavePageConfirmation) &&
            storeDetails &&
            storeDetails.config &&
            storeDetails.config.surveyLink
        ) {
            let link = storeDetails.config.surveyLink;
            link = link.replace('{?}', storeDetails.storeId);
            window.open(link, "_blank");
        }
    }
    isBirthdayValid() {
        let isValid = false;
        if (this.state.birthDay && this.state.birthMonth) {
            isValid = true;
        }
        return isValid;
    }
    onSkipBirthday() {
        dataLayer.push({
            'event': 'saveBirthday',
            'saveBirthdayAction': 'maybe later'
        });
        this.applyNewUserPromo();
        const referrerScreen = Util.getCookie(Util.COOKIE_NAMES.PREVIOUS_PAGE);
        Util.clearCookie(Util.COOKIE_NAMES.PREVIOUS_PAGE);
        Util.gotoRoute(referrerScreen ? referrerScreen : "/home", this.props.history);
        this.setState({ isBirthdayVisible: false }, () => {
            document.body.style.overflow = 'unset';
            const rootElement = document.querySelector('.home-screen');
            if (rootElement) {
                rootElement.removeEventListener('touchmove', this.preventTouchMoveDefault);
            }
            this.personalizedPromos();
            Util.scrollTop();

        })
    }
    onSaveBirthDay() {
        if (this.state.birthDay && this.state.birthMonth) {
            let message = "";
            const { locale } = this.props;
            let accountCreate = {};
            if (locale && locale.screens) {
                accountCreate = locale.screens.createAccount;
            }
            const customerDetail = Util.getLoggedInUserDetails();
            const storeDetail = Util.getStoreDetails();
            const request = {
                birthday: "1900-" + this.state.birthMonth + "-" + this.state.birthDay,
                countryCode:storeDetail.countryCode,
            };
            this.props.updateAccount(customerDetail.customer_id, request)
                .then(data => {
                    if (data && data.customer_id) {
                        this.applyNewUserPromo();
                        const referrerScreen = Util.getCookie(
                            Util.COOKIE_NAMES.PREVIOUS_PAGE
                        );

                        dataLayer.push({
                            'event': 'saveBirthday',
                            'saveBirthdayAction': 'birthday saved',
                            // 'userID': Util.getEmailId(),
                            eventCallback: () => {
                                if (referrerScreen) {
                                    Util.clearCookie(Util.COOKIE_NAMES.PREVIOUS_PAGE);
                                    Util.gotoRoute(referrerScreen, this.props.history);
                                } else {
                                    Util.gotoRoute("/home", this.props.history);
                                }
                                this.setState({ isBirthdayVisible: false }, () => {
                                    document.body.style.overflow = 'unset';
                                    const rootElement = document.querySelector('.home-screen');
                                    if (rootElement) {
                                        rootElement.removeEventListener('touchmove', this.preventTouchMoveDefault);
                                    }
                                    this.personalizedPromos()
                                    Util.scrollTop();
                                })
                            },
                            eventTimeout: 2000
                        });

                        window.toggleCommonToast(
                            true,
                            [accountCreate.birthdaySaved],
                            false,
                            5000,
                            false
                        );
                    }
                });
        } else {
            this.setState({ isBirthdayError: true });
        }
    }
    getDayOptions(birthMonth) {
        let options;
        let dates = [];
        if (birthMonth) {
            const monthLastDate = Number(
                Util.getMonthLastDateFromMonthValue(birthMonth)
            );
            for (let i = 1; i <= monthLastDate; i++) {
                dates.push(i);
            }
            options = dates.map((date, index) => {
                return (
                    <option key={"day-" + index} value={date}>
                        {date}
                    </option>
                );
            });
        } else {
            options = "";
        }

        return options;
    }
    onSelectMonthDateChange(label, event) {
        if (label) {
            if (label == "month") {
                if (this.state.birthDay && event.target.value) {
                    this.setState({ isBirthdayError: false });
                }
                this.setState({
                    ...this.state,
                    birthDay: "",
                    birthMonth: event.target.value
                });
            } else {
                if (this.state.birthMonth && event.target.value) {
                    this.setState({ isBirthdayError: false });
                }
                this.setState({ birthDay: event.target.value });
            }
        }
    }
    onChangeAgreeTermsChackbox() {
        this.props.setEmailOptIn(!this.props.isEmailOptIn);
    }
    onEyeClick(label) {
        if (label == "password") {
            this.setState({ showPassword: !this.state.showPassword });
        } else {
            this.setState({ showCPassword: !this.state.showCPassword });
        }
    }
    getErrorLabels(errorCode) {
        let message = "";
        const { locale } = this.props;
        let accountCreate = {};
        if (locale && locale.screens) {
            accountCreate = locale.screens.createAccount;
        }
        if (errorCode == ERROR_LABELS.PASSWORD.EMPTY) {
            message = accountCreate.enterPassword;
        } else if (errorCode == ERROR_LABELS.PASSWORD.INVALID) {
            message = accountCreate.validpasswordMsg;
        } else if (errorCode == ERROR_LABELS.PASSWORD.CEMPTY) {
            message = accountCreate.enterConfirmPassword;
        } else if (errorCode == ERROR_LABELS.PASSWORD.MISMATCH) {
            message = accountCreate.passwordNotMatching;
        } else if (errorCode == ERROR_LABELS.EMAIL.EMPTY) {
            message = accountCreate.validEmailMsg;
        } else if (errorCode == ERROR_LABELS.EMAIL.INVALID) {
            message = accountCreate.validEmailMsg;
        } else if (errorCode == ERROR_LABELS.EMAIL.INUSE) {
            message = accountCreate.accountAlreadyExisted;
        } else {
            message = accountCreate.thisFieldMandatory;
        }

        return message;
    }
    isCreateAccountDisabled() {
        let isDisabled = true;
        const {
            user,
            firstNameError,
            lastNameError,
            emailError,
            passwordError
        } = this.state;
        if (
            user.first_name &&
            user.last_name &&
            user.email &&
            user.password &&
            Util.isValidPassword(user.password) &&
            Util.isValidName(user.first_name) &&
            Util.isValidName(user.last_name) &&
            !firstNameError &&
            !lastNameError &&
            !emailError
        ) {
            isDisabled = false;
        }

        return isDisabled;
    }
    onInputChange(field, event) {
        const userObj = this.state.user;
        userObj[field] = event.target.value;
        this.setState({ userObj: event.target.value });
    }
    validateField(field, event) {
        if (field == "first_name") {
            if (!event.target.value) {
                this.setState({ firstNameError: true });
                this.setState({ invalidFirstName: false });
            } else {
                this.setState({ firstNameError: false });
                Util.isValidName(event.target.value)
                    ? this.setState({ invalidFirstName: false })
                    : this.setState({ invalidFirstName: true });
            }
        } else if (field == "last_name") {
            if (!event.target.value) {
                this.setState({ lastNameError: true });
                this.setState({ invalidLastName: false });
            } else {
                this.setState({ lastNameError: false });
                Util.isValidName(event.target.value)
                    ? this.setState({ invalidLastName: false })
                    : this.setState({ invalidLastName: true });
            }
        } else if (field == "email") {
            this.setState({ emailInUseError: "" });
            if (event.target.value && !Util.isValidEmail(event.target.value)) {
                this.setState({ emailError: ERROR_LABELS.EMAIL.INVALID });
            } else if (!event.target.value) {
                this.setState({ emailError: ERROR_LABELS.EMAIL.EMPTY });
            } else if (event.target.value && Util.isValidEmail(event.target.value)) {
                this.setState({ emailError: "" });
            }
        } else if (field == "password") {
            if (!event.target.value) {
                this.setState({ passwordError: ERROR_LABELS.PASSWORD.EMPTY });
            } else if (!Util.isValidPassword(event.target.value)) {
                this.setState({ passwordError: ERROR_LABELS.PASSWORD.INVALID });
            } else {
                this.setState({ passwordError: "" });
            }
        } else if (field == "cpassword") {
            if (!event.target.value) {
                this.setState({ cPasswordError: ERROR_LABELS.PASSWORD.CEMPTY });
            } else if (!Util.isValidPassword(event.target.value)) {
                this.setState({ cPasswordError: ERROR_LABELS.PASSWORD.INVALID });
            } else if (event.target.value != this.state.user.password) {
                this.setState({ cPasswordError: ERROR_LABELS.PASSWORD.MISMATCH });
            } else {
                this.setState({ cPasswordError: "" });
            }
        }
    }
    onLoginClick() {
        dataLayer.push({
            event: "membershipInteraction",
            membershipEventType: 'login',
            membershipEventLocation: "sign up module",
            membershipEventCTA: 'login',
            membershipEventAction: 'click',
            membershipEventTitle: 'login',
        })
        let queryParam = "?source=sign_up_module";
        // dataLayer.push({
        //   event: 'customerCapture',    
        //   userCaptureAction: 'login',
        //   userID: Util.getEmailId(),
        //   eventCallback: () => {
        const urlParams = Util.getQueryParams();
        if (
            urlParams &&
            Object.keys(urlParams).length > 0 &&
            urlParams["apply-promo"]
        ) {
            Util.gotoRoute(
                `/account/login/?apply-promo=${urlParams["apply-promo"]}`,
                this.props.history
            );
        } else {
            Util.gotoRoute(`/account/login/` + queryParam, this.props.history);
        }
        //   },
        //   eventTimeout: 2000
        // });
    }

    passwordFieldOnFocus = () => this.setState({ showPasswodHint: true });
    applyNewUserPromo = () => {
        const urlParams = Util.getQueryParams();
        if (
          urlParams &&
          Object.keys(urlParams).length > 0 &&
          urlParams["apply-promo"]
        ) {
          Util.addStringToStorage(
            Util.ADDITIONAL_APPLIED_COUPON,
            urlParams["apply-promo"]
          );
        }
      };
    onCreateAccount() {
        if (!this.isCreateAccountDisabled()) {
          const storeDetails = Util.getStoreDetails();
          let countryCode = "";
          storeDetails ? (countryCode = storeDetails.countryCode) : "";
          countryCode === "USA" ? (countryCode = "US") : "";
          countryCode === "CAN" ? (countryCode = "CA") : "";
          let loyaltyProgramDetails = {};
          try {
            loyaltyProgramDetails = JSON.parse(storeDetails.config.loyaltyProgramDetails) || {};    
          } catch (error) {
            console.log(error);
            loyaltyProgramDetails = {};
          }
          const request = {
            password: this.state.user.password,
            storeId: storeDetails.storeId,
            countryCode:storeDetails.countryCode,
            customer: {
              login: this.state.user.email.toLowerCase(),
              email: this.state.user.email.toLowerCase(),
              last_name: this.state.user.last_name,
              first_name: this.state.user.first_name,
              gender: 2,
              c_brand: "Coach",
              c_emailOptIn: this.props.isEmailOptIn ? 1 : 0,
              c_directMailOptIn: 2,
              c_homePhoneOptIn: 2,
              c_marketingSource: "OTL_LSS_REG",
              c_messageType: 1,
              c_mobilePhoneOptIn: 2,
              c_officePhoneOptIn: 2,
              c_smsOptIn: 2,
              c_sourceCode: "DWEOS",
              c_systemCountryCode: countryCode,
              c_customerGroup: "ACTIVEDW",
              c_lastModifiedDate: new Date().toISOString(),
              c_membershipID: '',
              c_outletPreferredStore: storeDetails.fMSSiteId || ''
            },
            fMSSiteId: storeDetails.fMSSiteId,
            loyaltyProgramDetails: loyaltyProgramDetails
          };
          this.props.createAccount(request).then(data => {
            if (data && data.customer_id) {
              // triggering welcome email start
    
               const requestForEmailTrigger = {
                EventType: "Welcome",
                TriggeringSystem: "SFMC",
                Brand: "COH",
                EmailPayload: {
                  Data: {
                    CUSTOMERKEY: this.state.user.email.toLowerCase(),
                    EMAILADDRESS: this.state.user.email.toLowerCase(),
                    HASHED_EMAIL_ADDRESS: sha256(this.state.user.email.toLowerCase()),
                    MEMBERSHIP_ENROLLMENT_DATE: Util.getClientDate(),
                    COUNTRY_CODE: "US",
                    LANGUAGE_CODE: "US_en",
                    SOURCE: "LSS",
                    MEMBERSHIP_ID: data['c_membershipID'] || "",
                    FIRST_NAME: this.state.user.first_name
                  }
                }
              } 
              if (storeDetails && storeDetails.config && storeDetails.config.useNewTriggerEmailRequest && storeDetails.config.useNewTriggerEmailRequest === 'true') {

                let locale = '';
                if (storeDetails.countryCode) {
                  const countryCode = storeDetails.countryCode;
                  if (countryCode === 'USA') {
                    locale = 'en_US';
                  } else if (countryCode === 'CAN') {
                    locale = 'en_CA';
                  }
                }
                requestForEmailTrigger.EmailPayload.Data.Locale = locale;
                requestForEmailTrigger.EmailPayload.Data.Insert_Date = Util.getClientDate();
                requestForEmailTrigger.EmailPayload.Data.Channel = 'OUTLET';
              }
              this.props.triggerEmail(requestForEmailTrigger).then(data => console.log(data));
    
              // triggering welcome email end
    
              const { locale } = this.props;
              let accountCreate = {};
              if (locale && locale.screens) {
                accountCreate = locale.screens.createAccount;
              }
              Util.scrollTop();
              this.setState({ showSignUpOverlay: false, isBirthdayVisible: true }, () => {
                //Scroll disabled for birthday page
                document.body.style.overflow = 'hidden';
                //TODO make root element as ref
                const rootElement = document.querySelector('.home-screen');
                if (rootElement) {
                    rootElement.addEventListener('touchmove', this.preventTouchMoveDefault, { passive: false });
                }

                dataLayer.push({
                  event: "dataLayer-initialized",
                  customAttributes:Util.getCustomAttributes(),
                  userID: Util.getEmailId(),
                  language: Util.getSelectedLanguage(),
                  pageName: "birthday",
                  pageType: "birthday",
                  storeID: Util.getStoreDetails().storeId,
                  storeDesc: Util.getStoreDetails().name,
                  flowConfig: Util.getGAFlowConfig(),
                  signedIn: (Util.isUserLoggedIn() == Util.LOGGEDIN_STATUS.LOGGED_IN) ? 'signed-in user' : 'guest'
                });
                dataLayer.push({
                  event: "appPageView",
                  appPageName: "creat account: birthday",
                  flowConfig: Util.getGAFlowConfig()
                });
    
                // const queryParamsObj = Util.getQueryParams();
                // if (queryParamsObj && queryParamsObj.source) {
                  dataLayer.push({
                    event: 'membershipInteraction',   
                    membershipEventType:'sign up',  
                    membershipEventTitle: 'sign up successful',  
                    membershipEventCTA: 'sign up successful', 
                    membershipEventAction:'submit', 
                    membershipEventLocation:this.insiderGateGroup === Util.INSIDER_GATE_GROUPS.WITH_INSIDER_GATE_AND_INCENTIVE ? 'gwp sign-up':'non gwp sign-up', 
                    isBSaved:(this.state.birthDay && this.state.birthMonth) ? "1":"0",
                    newsLetterOption :this.props.isEmailOptIn?'1':'0',
                    userID: Util.getEmailId(),
                    eventCallback: () => {
                      window.toggleCommonToast(
                        true,
                        [accountCreate.accountCreated],
                        false,
                        5000,
                        false
                      );
                    },
                    eventTimeout: 2000
                  });
                // }
                // else
                // {
                //     window.toggleCommonToast(
                //         true,
                //         [accountCreate.accountCreated],
                //         false,
                //         5000,
                //         false
                //       );
                // }
                // dataLayer.push({
                //   'event': 'signInCapture',    
                //   'userCaptureAction': 'registration complete',    
                //   'userID': sha256(request.customer.email),
                  
                // });
              });
            } else if (
              data &&
              data.fault &&
              data.fault.type &&
              data.fault.type == "LoginAlreadyInUseException"
            ) {
              // dataLayer.push({
              //   'event': 'signInCapture',    
              //   'userCaptureAction': 'account already exists error',    
              //   'userID': sha256(request.customer.email)
              // });
              this.setState({ emailInUseError: ERROR_LABELS.EMAIL.INUSE });
            } else if (data && data.fault && data.fault.message) {
              window.toggleCommonToast(true, [data.fault.message], true);
            }
          });
        }
      }


}


const mapStateToProps = state => {
    return {
        locale: state.locale,
        isEmailOptIn: state.store.isEmailOptIn
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        inLineSettings: (request, storeId) => dispatch(inLineSettings(request, storeId)),
        signupForAlerts: (request) => dispatch(signupForAlerts(request)),
        setGuestToken: (countryCode) => dispatch(setGuestToken(countryCode)),
        setEmailOptIn: status => dispatch(setEmailOptIn(status)),
        createAccount: request => dispatch(createAccount(request)),
        updateAccount: (customerId, request) =>dispatch(updateAccount(customerId, request)),
        triggerEmail: request => dispatch(triggerWelcomeEmail(request)),
        getPersonalizedPromos: () => dispatch(getPersonalizedPromos())




    };
};
  
  const connectedHome = connect(
    mapStateToProps,
    mapDispatchToProps
  )(Home);
  
  export default connectedHome;